import React, { createContext, useContext, useState } from 'react';

export type UserUidContextType = {
  userUid: string | undefined;
  setUserUid: (uid: string | undefined) => void;
};

const UserUidContext = createContext<UserUidContextType>(undefined);

export const UserUidProvider = ({ children }: { children: React.ReactNode }) => {
  const [userUid, setUserUid] = useState<string | undefined>(undefined);

  return (
    <UserUidContext.Provider value={{ userUid, setUserUid }}>
      {children}
    </UserUidContext.Provider>
  );
};

export const useUserUid = () => useContext(UserUidContext);
